import { Params } from '@angular/router';
import { Component, ElementRef } from '@angular/core';

import { DataSet } from '../../../../interfaces/DisplayInterfaces';
import { BaseWidget } from '../../BaseWidget/BaseWidget.component';
import { TableButtonInfo, GenericTableConfiguration } from './../../../../interfaces/WidgetInterfaces';

import { DisplayStateService } from '../../../../services/DisplayStateService';
import { AppStateService } from '../../../../services/AppStateService';
import { WebPlatformApiService } from '../../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../../services/ClientSettingsService';
declare var $: any;

@Component({
  selector: 'app-cache-data-admin',
  template: `<p><strong>Active Hours</strong>: Hours from first request that automatic updates occur.</p>
<p><strong>Inactive Hours</strong>: Hours from last request before cache is retired.</p>
<p *ngIf="warnForNewerMiddleLayer" class="bg-warning"><strong>Middle layer upgrade recommended</strong>: Additional cache information available from newer version of middle layer..</p>


<app-platform-table [Config]="tableConfig" (ButtonInfoClick)="RowSelected($event)" [Dataset]="dataSet"></app-platform-table>

<button type="button" class="btn btn-info btn-sm" (click)="Refresh()">Refresh</button>
<button type="button" class="btn btn-info btn-sm" (click)="Update()">Update</button> any cache expiring in the next
<input
  name="minutesAhead" type="text" style="width: 50px" [(ngModel)]="minutesAhead"> minutes
  <span *ngIf="updating" class="label label-warning">
    Updating...   <i class="fa fa-spinner fa-spin"></i></span>

  <div id="dataViewModal" tabindex="-1" role="dialog" class="modal fade">
    <!-- modal-big  -->
    <div class="modal-dialog modal-lg " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">Cached Data: {{selectedKey}}</span>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body">
           <app-platform-table *ngIf="displayDataSet" [Dataset]="displayDataSet" [SortAndfilterLocally]="true"></app-platform-table>
           <pre *ngIf="freeJsonData">
             {{freeJsonData | json}}
           </pre>
        </div>
      </div>
    </div>
  </div>`,
  styles: [`.modal-lg{
   max-width:90%;
   max-height:90%;
}

.modal-lg .modal-body{
  overflow-y:auto;
}`]
})
export class CacheDataAdminComponent extends BaseWidget {

  managedCacheDataStatusList: string[][] = [];
  minutesAhead = 10;
  updating = false;
  isAdmin = false;
  columns: any[];
  dataSet: DataSet = undefined;
  displayDataSet: DataSet = undefined;
  freeJsonData: any = undefined;
  selectedKey: string = undefined;
  userFilter = '';
  warnForNewerMiddleLayer = false;

  // [ShowColumnDropdowns]="true" [ButtonInfoList]="buttonInfoList" (ButtonInfoClick)="RowSelected($event)"  [Dataset]="dataSet" [SortAndfilterLocally]="true" 

  tableConfig: GenericTableConfiguration = {
    showColumnDropdowns: true,
    buttonInfoList:  [{name: 'update', class: '', iconClass: 'fa fa-refresh', text: '' }],
    sortAndfilterLocally: true,
    tableColumnRules: [
      {      
        columnName: 'Remaining Minutes',
        alternateColorOnValueChange: false,
        heatmapRules : {low: '10', high: '0'} 
      }, 
      {
        columnName: 'Key',
        maxTextLength: 100
      }

  ]};

  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }
  onInitialize() {
    if (this.displayStateService.appState.current.user !== undefined) {
      this.isAdmin = this.displayStateService.appState.current.userIsAdmin;
      if (this.isAdmin) {
        this.tableConfig.buttonInfoList.push({name: 'view', class: '', iconClass: 'fa fa-table', text: '' });
      }      
    }
    this.Refresh();
  }

  Refresh() {
    this.dataSet = undefined;
    this.webPlatformApiService.GetManagedCacheDataStatus().subscribe(x => {

      this.dataSet = {columns: ['Policy', 'Key', 'Remaining Minutes', 'Cache Rule', 'Active Hours', 'Inactive Hours'], data: [] };

      this.dataSet.data = x
        .filter( r => r[1].indexOf('localhost:57600') === -1)
        .map(r => {
          if (Number(r[2]) > 100000) {
            r[2] = 'permanent';
          }
          if (r.length === 3) {
            r.push('');
            r.push('');
            r.push('');
            this.warnForNewerMiddleLayer = true;
          }
          return r;
        });
    });
  }

  RowSelected(params: Params) {
    const buttonInfo = params['buttonInfo'] as TableButtonInfo;
    const buttonName = buttonInfo.name;
    const row = params['row'];
    if (buttonName === 'view') {
      this.ViewData(row[1])
    } else if (buttonName === 'update') {
      this.UpdateForce(row[1])
    }  
  }  
  
  ViewData(key: string) {
    key = encodeURIComponent(key);
    this.webPlatformApiService.GetCacheDataByKey(key).subscribe(x => {
      this.displayDataSet = undefined;
      this.freeJsonData = undefined;

      const tempDs = <DataSet>x.Payload;
      if (tempDs && tempDs.columns) {
        this.displayDataSet = <DataSet>x.Payload;
      } else {
        this.freeJsonData = x.Payload;;
      }
      
      this.selectedKey = key;
      $('#dataViewModal').modal('show');
    });
  }

  UpdateForce(key: string) {
    this.updating = true;
    this.webPlatformApiService.ForceUpdateByKey(encodeURIComponent(key)).subscribe(x => {
      this.Refresh();
      this.updating = false;
    });
  }

  Update() {
    this.updating = true;
    this.webPlatformApiService.UpdateCacheStatus(this.minutesAhead).subscribe(x => {
      this.Refresh();
      this.updating = false;
    });
  }
}
